import React, { useEffect, useState } from "react";
import { log } from "@/lib/log";

const KEY = "archedia-intro-seen";

export const BrandIntro = () => {
  const [show, setShow] = useState(() => {
    try { if (sessionStorage.getItem(KEY) === "1") return false; } catch (e) { log.warn("sessionStorage unavailable", e); }
    return true;
  });

  useEffect(() => {
    try { sessionStorage.setItem(KEY, "1"); } catch (e) { log.warn("sessionStorage unavailable", e); }
    const dismiss = () => setShow(false);
    const opts = { passive: true, once: true };
    window.addEventListener("pointerdown", dismiss, opts);
    window.addEventListener("keydown", dismiss, opts);
    window.addEventListener("wheel", dismiss, opts);
    window.addEventListener("touchstart", dismiss, opts);
    return () => {
      window.removeEventListener("pointerdown", dismiss);
      window.removeEventListener("keydown", dismiss);
      window.removeEventListener("wheel", dismiss);
      window.removeEventListener("touchstart", dismiss);
    };
  }, []);

  if (!show) return null;

  return (
    <div
      className="brand-intro fixed inset-0 z-[200] flex flex-col items-center justify-center overflow-hidden"
      style={{ background: "#071711" }}
      data-testid="brand-intro"
      onAnimationEnd={(e) => { if (e.target === e.currentTarget) setShow(false); }}
    >
      <svg className="absolute" width="360" height="360" viewBox="0 0 360 360" fill="none" style={{ opacity: 0.35 }}>
        <path className="intro-line" d="M180 40 L320 320 L40 320 Z" stroke="var(--accent-gold)" strokeWidth="1" strokeDasharray="1000" strokeDashoffset="1000" />
      </svg>

      <div className="relative flex items-baseline font-serif" style={{ color: "#F5F3ED" }}>
        <span className="intro-arc text-6xl font-light tracking-tight sm:text-7xl">ARCH</span>
        <span className="intro-edia gold-gradient-text text-6xl font-light tracking-tight sm:text-7xl">EDIA</span>
      </div>

      <div className="intro-name overline mt-6">ARCHEDIA SOLUTIONS</div>

      <p className="intro-tag mt-4 font-serif text-lg italic sm:text-xl" style={{ color: "#B4C4BA" }}>
        Perspective Builds Possibilities.
      </p>
    </div>
  );
};

export default BrandIntro;
